import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { ContractRateType } from '../models/ContractRateType';
import { SelectItem } from '../models/SelectItem';

@Injectable({
  providedIn: 'root',
})
export class ContractRateTypeService {
  apiRoot: string;
  statuses: SelectItem[] = [];

  constructor(private http: HttpClient) {
    this.apiRoot = environment.cmApiRoot.url;
  }

  public getContractRateTypes(): Observable<ContractRateType[]> {

    return this.http.get<ContractRateType[]>(`${this.apiRoot}/api/ContractRateTypes`);
  }


}
